export default __webpack_public_path__ + "static/media/tr_1.97a367e9.mp3";